import { useLanguage } from '@jablotron/lib.spa-lang';
import { type FooterContact, type FooterLink, getFooterContact, getFooterUsefulInfoLinks } from './footer-data';

/** The legal/contact block for the language the site is currently shown in. */
export function useFooterContact(): FooterContact {
  const [language] = useLanguage();

  return getFooterContact(language);
}

/** The "Useful information" links (GDPR, Data Act) for the language the site is currently shown in. */
export function useFooterUsefulInfoLinks(): FooterLink[] {
  const [language] = useLanguage();

  return getFooterUsefulInfoLinks(language);
}
